import { REHYDRATE } from 'redux-persist/lib/constants';
import uniq from 'lodash/uniq';

const initial = {
  recent: []
};

// reducers
export default function recentlyViewed(state = initial, action) {
  switch (action.type) {
    case 'PUT_RECENT_PRODUCTS':
      if (action.recent && state.recent.includes(action.recent)) {
        return { ...state };
      }
      return {
        ...state,
        recent: [...state.recent, action.recent]
      };

    case 'FETCH_RECENT_PRODUCTS':
      const { payload = {} } = action;
      const { recentlyViewed = {} } = payload;
      let { recent = [] } = recentlyViewed;
      let nextState = {
        ...state,
        recent: [...recent, ...state.recent]
      };
      nextState.recent = uniq(nextState.recent);
      if (nextState.recent.length > 11) {
        nextState.recent.shift();
      }
      return {
        ...nextState
      };

    default:
      return state;
  }
}
